import { createContext, useContext, useEffect, useReducer } from 'react'
import { initialQuestion, questionReducer } from '../../reducers/questionReducer'
import { useGetLocalStorage } from '../../hooks/useGetLocaStorage'
import { ADD_QUESTION_MODULE } from '../../reducers/reducesTypes'

const QuestionContext = createContext(null)
const QuestionDispatchContext = createContext(null)

export function QuestionProvider({ children }) {
  const [question, dispatch] = useReducer(questionReducer, initialQuestion)
  const module = useGetLocalStorage('module')
  useEffect(() => {
    if (Object.keys(module).length > 0) {
      dispatch({
        type: ADD_QUESTION_MODULE,
        payload: {
          id: module.id,
          moduleType: module.tipe_modul,
          moduleName: module.nama_modul,
          timer: Number(module.waktu_pengerjaan),
          totalQuestion: Number(module.jumlah_soal),
          offset: Number(module.offset) || 0,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  return (
    <QuestionContext.Provider value={question}>
      <QuestionDispatchContext.Provider value={dispatch}>
        {children}
      </QuestionDispatchContext.Provider>
    </QuestionContext.Provider>
  )
}

export function useQeustion() {
  return useContext(QuestionContext)
}
export function useQuestionDispatch() {
  return useContext(QuestionDispatchContext)
}
